/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Input, Renderer2, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Directive } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { PulseAnimation } from 'src/app/app-data/animations/pulse-animation';

/**
 * Directive version of [[PulseAnimation]]. Requires only
 * - an observable trigger to the animation.
 * - class name
 * - duration
 *
 * It is still recommned to extend this directive and set defaults on duration and class.
 * See [[ShakeAnimationDirective]] on [[TicketEditComponent]] for an example
 */

@Directive({
	selector: '[pulseAnimation]',
})
export class PulseAnimationDirective implements OnInit, OnDestroy {
	private pulseAnimation: PulseAnimation;
	private shutdownSubject = new Subject<void>();

	@Input() protected animationDuration: number;
	@Input() protected animationClass: string;
	@Input('pulseAnimation') protected trigger$: Observable<any>;

	constructor(private renderer: Renderer2, private elementRef: ElementRef) {}

	public ngOnInit() {
		this.pulseAnimation = new PulseAnimation(
			this.renderer,
			this.elementRef,
			this.animationDuration,
			this.animationClass
		);
		this.pulseAnimation.observe(this.trigger$);
	}

	public ngOnDestroy() {
		this.shutdownSubject.next();
		this.pulseAnimation.destroy();
	}
}
